import React from "react";
import { useUscSelector } from "../../../redux/store";
import { useUscLabel } from "../../../utils/labels";
import { useBreakpoint } from "../../../../../common-deprecated/themes/common";
import useExtrasBuyOrReserveLabels from "../../../hooks/useExtrasBuyOrReserveLabels";
import Text from "../styles/atoms/Text";
import Disclosure from "../styles/molecules/Disclosure";
import Icon from "../styles/Icon";
import Button from "../styles/atoms/Button";
import * as Styles from "./ReservationProcess.styles";

const CheckoutProcess = (): JSX.Element => {
    const reservationInfoUrl = useUscSelector((state) => state.uscSettings.reservationInfoUrl);
    const openCheckoutStepsByDefault = useUscSelector((state) => state.uscSettings.openCheckoutStepsByDefault);
    const { extrasCheckoutStepsTitle, extrasCheckoutStepsDescription, extrasCheckoutStepsItems } =
        useExtrasBuyOrReserveLabels();
    const [title, description, items] = useUscLabel([
        extrasCheckoutStepsTitle,
        extrasCheckoutStepsDescription,
        extrasCheckoutStepsItems,
    ]);
    const steps = items.split(";");
    const reservationInfoLabel = useUscLabel("uscExtrasCheckoutInfo");

    const isMobile = useBreakpoint("down", "md");

    return (
        <Disclosure variant="default" open={openCheckoutStepsByDefault}>
            <summary>
                <div>
                    {!isMobile && <Icon variant="website" iconSize="medium" />}
                    <Text tag="h2" variant="h6">
                        {title}
                    </Text>
                </div>
                <Icon variant="chevron-down" />
            </summary>
            <Styles.DisclosureBody>
                <Text tag="p" variant="body-book">
                    {description}
                </Text>
                <div>
                    {steps.length > 0 && (
                        <Styles.ReservationProcessList role="list">
                            {steps.map((step, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <li role="listitem" key={`${step}-${index}`}>
                                    {step}
                                </li>
                            ))}
                        </Styles.ReservationProcessList>
                    )}
                    {reservationInfoUrl && (
                        <Button
                            variant="icon-text"
                            textUnderline
                            href={reservationInfoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Icon variant="info" />
                            <span>{reservationInfoLabel}</span>
                        </Button>
                    )}
                </div>
            </Styles.DisclosureBody>
        </Disclosure>
    );
};

export default CheckoutProcess;
